export default window.toastr
